import LegalPage from '../../components/common/LegalPage';

const SECTIONS = [
  {
    title: 'Acceptance of Terms',
    body: `By accessing or using Bhadralok's website, mobile application, or any related services ("Services"), you agree to be bound by these Terms of Use ("Terms"). If you do not agree to these Terms, please do not use our Services.

We reserve the right to modify these Terms at any time. Continued use of our Services after any changes constitutes your acceptance of the new Terms.`,
  },
  {
    title: 'Use of Our Services',
    body: `You may use our Services only for lawful purposes and in accordance with these Terms. You agree not to:

• Use our Services in any way that violates applicable laws or regulations
• Engage in any conduct that restricts or inhibits anyone's use or enjoyment of the Services
• Use automated tools, bots, or scrapers to access our website without permission
• Attempt to gain unauthorized access to any part of our Services
• Transmit any unsolicited commercial communications
• Impersonate any person or entity or misrepresent your affiliation`,
  },
  {
    title: 'Account Registration',
    body: `To access certain features, you must register for an account. You agree to:

• Provide accurate, complete, and current information
• Maintain the security of your password and account
• Notify us immediately of any unauthorized use of your account
• Take responsibility for all activities that occur under your account

We reserve the right to suspend or terminate accounts that violate these Terms.`,
  },
  {
    title: 'Products and Pricing',
    body: `All product descriptions, images, and specifications on our website are for informational purposes only. We reserve the right to:

• Modify product specifications without notice
• Limit quantities available for purchase
• Discontinue any product at any time
• Correct pricing errors (orders placed at incorrect prices may be cancelled with full refund)

Prices displayed include applicable GST unless stated otherwise. Shipping charges are additional and displayed at checkout.`,
  },
  {
    title: 'Order Acceptance',
    body: `Placing an order does not constitute a binding contract. Orders are subject to acceptance and availability. We reserve the right to refuse or cancel any order for reasons including but not limited to:

• Product unavailability
• Errors in product or pricing information
• Suspected fraudulent activity
• Delivery restrictions to your location

You will be notified and fully refunded if your order is cancelled.`,
  },
  {
    title: 'Intellectual Property',
    body: `All content on our website, including text, graphics, logos, images, audio clips, and software, is the property of Bhadralok or its licensors and is protected by Indian and international intellectual property laws.

You may not reproduce, distribute, modify, create derivative works of, publicly display, or exploit any content from our website without our prior written consent. Limited personal, non-commercial use is permitted.`,
  },
  {
    title: 'User-Generated Content',
    body: `If you submit reviews, photos, or other content to our platform, you grant Bhadralok a non-exclusive, royalty-free, perpetual license to use, reproduce, modify, and display that content in connection with our Services and marketing.

You represent that you have all rights necessary to grant this license, and that your content does not infringe any third-party rights.`,
  },
  {
    title: 'Disclaimer of Warranties',
    body: `Our Services are provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that our Services will be uninterrupted, error-free, or free of viruses or harmful components.

To the fullest extent permitted by law, we disclaim all warranties, including implied warranties of merchantability, fitness for a particular purpose, and non-infringement.`,
  },
  {
    title: 'Limitation of Liability',
    body: `To the maximum extent permitted by applicable law, Bhadralok shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your use of, or inability to use, our Services.

Our total liability to you for any claim arising from these Terms or your use of our Services shall not exceed the amount you paid to us in the 3 months preceding the claim.`,
  },
  {
    title: 'Governing Law',
    body: `These Terms are governed by the laws of India, specifically the laws of the State of West Bengal, without regard to conflict of law principles. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts of Kolkata, West Bengal, India.`,
  },
  {
    title: 'Contact Information',
    body: `For questions about these Terms of Use, please contact us:

Email: legal@bhadralok.com
Address: Bhadralok Studio, 12/3 College Street, North Kolkata, West Bengal — 700073
Phone: +91 98765 43210`,
  },
];

export default function TermsOfUse() {
  return (
    <LegalPage
      title="TERMS OF USE"
      label="Please Read Carefully"
      lastUpdated="January 1, 2025"
      intro="These Terms of Use govern your use of Bhadralok's website, services, and products. By using our Services, you agree to these terms in their entirety."
      sections={SECTIONS}
    />
  );
}
